import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { UserService } from '../../../core/services/user.service';

@Component({
    selector: 'cmn-user-box',
    templateUrl: './user-box.component.html',
    styleUrls: ['./user-box.component.scss']
})
export class UserBoxComponent implements OnInit {

    public user: {name, email, id, impersonated} = null;
    public userActions: Array<{}> = [{
        text: 'Zmień hasło',
        click: () => {
            this.router.navigate(['profil/zmien-haslo']);
        }
    },{
        text: 'Edytuj profil',
        click: () => {
            this.router.navigate(['profil/edytuj-profil']);
        }
    }, {
        text: 'Wyloguj',
        click: () => {
            this.userService.logout().then(() => {
                this.router.navigate(['logowanie']);
            });
        }
    }];

    constructor(
        private userService: UserService,
        private router: Router,
    ) {
        this.user = this.userService.user;
    }

    ngOnInit() {
        const sub = this.userService.userIsLogin$.subscribe(
            () => {
                this.user = this.userService.user;
            },
            () => {
            },
            () => {
                if (!isNullOrUndefined(sub)) {
                    sub.unsubscribe();
                }
            }
        );
    }
}
